export default __webpack_public_path__ + "b80f43481358373e4c9d6eb87f7f2a3a.png";